export const GET_VALUES = "v2/dashboard/values";
export const GET_CLIENTS = "v2/dashboard/clients";